import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './FJCreationPreview.module.less';
import FJCreationPreviewItem from './FJCreationPreviewItem.jsx';
import FJLocalStore from '../../../store/FJLocalStore';
import { useEffect, useRef, useState } from 'react';
import FJUtil from '../../../util/FJUtil';
const GAP = 12;
const PADDING = 40;
const H_PADDING = 50;

const FJCreationPreview = props => {
    const { use, active, list } = props;

    const containerRef = useRef(null);
    const listRef = useRef(null);
    const titleRef = useRef(null);
    const [viewSize, setViewSize] = useState({
        width: 342,
        height: 342,
    });

    const [tempList, setTempList] = useState([]);
    const randomIndex = useRef(Math.floor(Math.random() * list.length));

    useEffect(() => {
        randomIndex.current = Math.floor(Math.random() * list.length);
        setTempList(list[randomIndex.current] || []);
    }, [list.length]);

    const _updateUI = FJUtil.throttle(() => {
        if (containerRef.current && listRef.current && titleRef.current) {
            const titleHeight = titleRef.current.getBoundingClientRect().height + 30;
            const { width, height } = containerRef.current.getBoundingClientRect();
            const h = (height - titleHeight - H_PADDING * 2 - GAP) / 2;
            const w = (width - PADDING * 2 - GAP * 2) / 3;
            const pixel = Math.min(w, h);
            setViewSize({ width: pixel, height: pixel });
            listRef.current.style.width = `${pixel * 3 + GAP * 2}px`;
            listRef.current.style.height = `${pixel * 2 + GAP}px`;
        }
    }, 100);
    useEffect(() => {
        if (active) {
            setTimeout(() => {
                _updateUI();
            }, 200);
            window.addEventListener('resize', _updateUI);
            return () => {
                window.removeEventListener('resize', _updateUI);
            };
        }
    }, [active]);
    return (
        <div
            className={classNames(styles.container)}
            ref={containerRef}
            style={{ display: active ? 'flex' : 'none', padding: `${H_PADDING}px ${PADDING}px` }}
        >
            <div className={styles.title} ref={titleRef}>
                {FJLocalStore._('start-fast-with-these-preset-images')}
            </div>
            <div className={styles.list} ref={listRef}>
                {tempList.map((item, idx) => (
                    <FJCreationPreviewItem
                        key={idx}
                        data={item}
                        randomIndex={randomIndex.current + 1}
                        use={use}
                        width={viewSize.width}
                        height={viewSize.height}
                    />
                ))}
            </div>
        </div>
    );
};

FJCreationPreview.propTypes = {
    use: PropTypes.func,
    active: PropTypes.bool,
    list: PropTypes.array,
};

export default FJCreationPreview;
